import * as React from "react";
import { Typography, useMediaQuery, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./NavBar.styles";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IMenuItem } from "./MainNavBarItems";
import { useSelector } from "react-redux";
import { BasketOverviewPopover } from "../BasketOverviewPopover/BasketOverviewPopover";
import { useAuthContext } from "../../../auth/AuthProvider";
import { isPrivilegedUser, isUser } from "../../../utilities/userUtils";
import { useIsUserLegallyOk } from "../../../hooks/useIsUserLegallyOk";
import { getNotification } from "../../../utilities/notificationUtils";

export interface IHeaderProps extends WithStyles<typeof styles> {
    menuItems: IMenuItem[];
}

const NavBarPure: React.FunctionComponent<IHeaderProps> = ({ menuItems, classes }: IHeaderProps) => {
    const authContext = useAuthContext();
    const { t } = useTranslation();
    const basketItems = useSelector(state => state.basket?.items) || [];
    const matches = useMediaQuery("(min-width:450px)");
    const userId = authContext?.user?.id;
    const isUserLegalyOk = useIsUserLegallyOk(userId);
    const notification = getNotification();
    
    return (
        <>
            <div className={matches ? classes.root : classes.rootMobile}>
                <div className={classes.navElements}>
                    <div>
                        <ul>
                            {menuItems.map((menuItem, index) => (
                                <li key={index}>
                                    <NavLink to={menuItem.url || menuItem.path} className={classes.link} key={index}>
                                        {menuItem.icon || t(menuItem.labelId)}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <ul>
                            {isUser(authContext) && isUserLegalyOk && (
                                <li key="my-account">
                                    <NavLink to="/my-account" className={classes.link} key="my-account">
                                        {t("manageAccount.myAccount")}
                                    </NavLink>
                                </li>
                            )}
                            {isPrivilegedUser(authContext) && isUserLegalyOk && (
                                <li key="admin">
                                    <NavLink to="/admin" className={classes.link} key="admin">
                                        {t("general.admin")}
                                    </NavLink>
                                </li>
                            )}
                            <li key="basket">
                                <BasketOverviewPopover items={basketItems} />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {notification && (
                <div>
                    <Typography variant="h3" align="center" className={classes.notification}>
                        {notification.message}
                    </Typography>
                </div>
            )}
        </>
    );
};

export const NavBar = withStyles(styles)(NavBarPure);
